import { Component } from '@angular/core';

@Component({
  selector: 'app-non-paye-fac-f',
  templateUrl: './non-paye-fac-f.component.html',
  styleUrls: ['./non-paye-fac-f.component.scss']
})
export class NonPayeFacFComponent {}
